import script from "./DeviceAlarm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceAlarm.vue?vue&type=script&setup=true&lang=js"

import "./DeviceAlarm.vue?vue&type=style&index=0&id=548193b2&lang=less&scoped=true"

import exportComponent from "D:\\yisa_project\\访客预约系统\\vrs_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548193b2"]])

export default __exports__